// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../index';

import { gql } from 'graphql-tag';
export const CatalogueEngagementRingInputFragmentDoc = gql`
    fragment catalogueEngagementRingInput on CatalogueEngagementRing {
  catalogueCode
  centreStoneConstraints {
    shape {
      systemCode
    }
  }
  slug
  primaryMetal {
    systemCode
  }
  suffixSlug
}
    `;